import {Injectable} from "@angular/core";
import {DealListGqlModel} from "./deal-list.gql-model";
import {Apollo} from "apollo-angular";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class DartDealService {
  private url: string = "/api/dartdeals";

  constructor(
    private http: HttpClient,
    private apollo: Apollo,
  ) {}

  async getFullList(projectId?: string): Promise<DealListGqlModel> {
    const query = DealListGqlModel.query;
    const variables = DealListGqlModel.variables(projectId);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(DealListGqlModel.mapper)
      .toPromise();
  }

  getDealsFromProject(projectId): Promise<any> {
    return this.http.get(`${this.url}/deals-from-project?projectId=${projectId}`)
      .toPromise();
  }

  remove(dealId): Promise<any> {
    return this.http.get(`${this.url}/remove?dealId=${dealId}`)
      .toPromise();
  }
}
